import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import SearchableDropdown from "../../../../Core/Fields/Floating/SearchableDropdown";
import GetIcon from "../../../../utils/Icon";
const Tab4Table1 = ({
	setselected_customer_details_data,
	list_customer_data,
	list_customer_group,
	setRows5,
	rows5,
}) => {
	const createNewRow = () => ({
		customer_name: "",
		customer_group: "",
		ref_code: "",
	});

	const tableRef = useRef();
	const dropdownRef = useRef(null);
	const dropdownRef1 = useRef(null);
	const [rowsPerPage] = useState(10);
	// For "warehouse" dropdown
	const [offset, setOffset] = useState(0);
	const [search_input, setsearch_input] = useState("");

	// For "warehouse_request" dropdown
	const [offset1, setOffset1] = useState(0);
	const [search_input1, setsearch_input1] = useState("");

	// Pagination control (optional but required if used)
	const [hasMore, setHasMore] = useState(true); // for warehouse
	const [hasMoreCategory, setHasMoreCategory] = useState(true); // for warehouse_request

	const [customer_list, setcustomer_list] = useState([]);
	const [customer_group_list, setcustomer_group_list] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	// const [rows, setRows5] = useState([createNewRow()]);
	const [selectedRows, setSelectedRows] = useState([]);
	// const [search_input, setsearch_input] = useState("");
	const [focusedCell, setFocusedCell] = useState({
		rowIndex: null,
		field: null,
	});
	const [showDropdown, setShowDropdown] = useState({
		rowIndex: null,
		field: null,
	});
	const isAllSelected =
		rows5.length > 0 && selectedRows.length === rows5.length;
	const indexOfLastRow = currentPage * rowsPerPage;
	const indexOfFirstRow = indexOfLastRow - rowsPerPage;
	const currentRows = rows5.slice(indexOfFirstRow, indexOfLastRow);

	const handleSelectAll = (e) => {
		if (e.target.checked) {
			const allRowIndices = rows5.map((_, index) => index);
			setSelectedRows(allRowIndices);
		} else {
			setSelectedRows([]);
		}
	};

	const getcustomer_data = async (newOffset = 0, searchText = "") => {
		const res = await list_customer_data({
			start: newOffset,
			search_input: searchText,
		});
		const products = res?.data?.data || [];
		// console.log('tax cat list:',products)
		if (newOffset === 0) {
			setcustomer_list(products);
		} else {
			setcustomer_list((prev) => [...prev, ...products]);
		}
		setHasMore(products.length === 20);
	};
	const getcustomer_group_data = async (newOffset = 0, searchText = "") => {
		const res = await list_customer_group({
			start: newOffset,
			search_input: searchText,
		});
		const products = res?.data?.data || [];
		// console.log('tax cat list:',products)
		if (newOffset === 0) {
			setcustomer_group_list(products);
		} else {
			setcustomer_group_list((prev) => [...prev, ...products]);
		}
		setHasMore(products.length === 20);
	};

	// const updateRow = (index, field, value) => {
	//   const updatedRows = [...rows];
	//   updatedRows[index][field] = value;
	//   setRows5(updatedRows);
	//   setselected_customer_details_data(updatedRows)
	// };
	const updateRow = (index, field, value) => {
		const updatedRows = [...rows5];

		// Ensure item exists
		if (!updatedRows[index].item) {
			updatedRows[index].item = {};
		}

		updatedRows[index].item[field] = value;

		setRows5(updatedRows);
		setselected_customer_details_data(updatedRows);
	};

	const toggleRowSelection = (index) => {
		setSelectedRows((prev) =>
			prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
		);
	};

	const handleAddRow = () => {
		const newRows = [...rows5, createNewRow()];
		setRows5(newRows);
		setselected_customer_details_data(newRows);
		const lastPage = Math.ceil(newRows.length / rowsPerPage);
		if (currentPage !== lastPage) {
			setCurrentPage(lastPage);
		}
	};

	const handleDeleteSelectedRows = () => {
		const updatedRows = rows5.filter((_, idx) => !selectedRows.includes(idx));
		setRows5(updatedRows);
		setselected_customer_details_data(updatedRows);
		setSelectedRows([]);
		const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
		if (currentPage > lastPage) {
			setCurrentPage(lastPage);
		}
	};

	useEffect(() => {
		getcustomer_data(0, "");
		getcustomer_group_data(0, "");
	}, []);

	useEffect(() => {
		const cols = tableRef.current.querySelectorAll("th");
		cols.forEach((col) => {
			const resizer = document.createElement("div");
			resizer.className = "resizer";
			col.appendChild(resizer);

			let x = 0;
			let w = 0;

			const onMouseDown = (e) => {
				x = e.clientX;
				w = col.offsetWidth;

				document.addEventListener("mousemove", onMouseMove);
				document.addEventListener("mouseup", onMouseUp);
			};

			const onMouseMove = (e) => {
				const dx = e.clientX - x;
				col.style.width = `${w + dx}px`;
			};

			const onMouseUp = () => {
				document.removeEventListener("mousemove", onMouseMove);
				document.removeEventListener("mouseup", onMouseUp);
			};

			resizer.addEventListener("mousedown", onMouseDown);
		});
	}, []);

	return (
		<div className="">
			<table className="table table-bordered mb-1" ref={tableRef}>
				<thead className="tableHead1">
					<tr>
						{[
							"Action",
							"S.No",
							"Customer Name",
							"Customer Group",
							"Ref Code",
							// <GetIcon iconName="PiSlidersHorizontalBold" size={12} />,
						].map((title, i) => {
							const isIcon = typeof title !== "string";
							const defaultWidths = {
								Action: "20px",
								"S.No": "20px",
								"Customer Name": "220px",
								"Customer Group": "220px",
								"Ref Code": "220px",
								// Action1: "100px",
							};

							return (
								<th
									key={i}
									style={{
										fontSize: "7px",
										position: "relative",
										textAlign:
											title === "Action" ||
											title === "S.No" ||
											title === "isIcon"
												? "center"
												: "center",
										width:
											typeof title === "string"
												? defaultWidths[title] || "220px"
												: "220px",
										minWidth:
											typeof title === "string"
												? defaultWidths[title] || "220px"
												: "220px",
									}}
								>
									{title === "Action" ? (
										<input
											type="checkbox"
											className="form-check-input"
											style={{
												backgroundColor: isAllSelected ? "#270b79" : "",
												borderColor: isAllSelected ? "#270b79" : "",
												fontSize: "15px",
											}}
											checked={isAllSelected}
											onChange={handleSelectAll}
										/>
									) : isIcon ? (
										<div
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											{title}
										</div>
									) : (
										title
									)}
								</th>
							);
						})}
					</tr>
				</thead>

				<tbody>
					{currentRows.map((row, index) => {
						const globalIndex = indexOfFirstRow + index;
						return (
							<tr key={globalIndex}>
								<td className="p-0" style={{ cursor: "pointer" }}>
									<p
										className="m-0"
										style={{ position: "relative", top: "5px" }}
									>
										{selectedRows.includes(globalIndex) ? (
											<span onClick={() => toggleRowSelection(globalIndex)}>
												<input
													type="checkbox"
													className="form-check-input"
													style={{
														backgroundColor: "#270b79",
														fontSize: "15px",
														borderColor: "#270b79",
													}}
													checked
												/>
											</span>
										) : (
											<span onClick={() => toggleRowSelection(globalIndex)}>
												<input
													type="checkbox"
													className="form-check-input"
													style={{ fontSize: "15px" }}
												/>
											</span>
										)}
									</p>
								</td>
								<td
									style={{
										textAlign: "center",
										fontSize: "0.8rem",
										padding: "0.5rem",
									}}
								>
									{globalIndex + 1}
								</td>

								<td className="p-0">
									<SearchableDropdown
										globalIndex={globalIndex}
										field="customer_name"
										value={row.item?.customer_name || row.customer_name || ""}
										onChange={(val) =>
											updateRow(globalIndex, "customer_name", val)
										}
										onSearch={(text) => getcustomer_data(0, text)}
										dropdownData={customer_list}
										placeholder="Select Customer Name"
										focusedCell={focusedCell}
										setFocusedCell={setFocusedCell}
										showDropdown={showDropdown}
										setShowDropdown={setShowDropdown}
										dropdownRef={dropdownRef1}
										setOffset={setOffset1}
										offset={offset1}
										search_input={search_input1}
										hasMore={hasMoreCategory}
										getData={getcustomer_data}
										createNewUrl="/master/customer/create-customer"
										createNewLabel="+ Create New Customer"
									/>
								</td>
								<td className="p-0">
									<SearchableDropdown
										globalIndex={globalIndex}
										field="customer_group"
										value={row.item?.customer_group || row.customer_group || ""}
										onChange={(val) =>
											updateRow(globalIndex, "customer_group", val)
										}
										onSearch={(text) => getcustomer_group_data(0, text)}
										dropdownData={customer_group_list}
										placeholder="Select Customer Group"
										focusedCell={focusedCell}
										setFocusedCell={setFocusedCell}
										showDropdown={showDropdown}
										setShowDropdown={setShowDropdown}
										dropdownRef={dropdownRef1}
										setOffset={setOffset1}
										offset={offset1}
										search_input={search_input1}
										hasMore={hasMoreCategory}
										getData={getcustomer_group_data}
										createNewUrl="/"
										createNewLabel="+ Create Customer Group"
									/>
								</td>

								<td
									className="p-0 d-flex justify-content-center"
									style={{
										border:
											focusedCell.rowIndex === globalIndex &&
											focusedCell.field === "ref_code"
												? "0.3px solid #270b79"
												: "",
									}}
								>
									<input
										type="text"
										placeholder="Ref Code"
										onFocus={() =>
											setFocusedCell({
												rowIndex: globalIndex,
												field: "ref_code",
											})
										}
										onBlur={() =>
											setFocusedCell({ rowIndex: null, field: null })
										}
										className="form-control tableinput noborder"
										style={{ fontSize: "0.8rem", textAlign: "center" }}
										value={row?.item?.ref_code || row?.ref_code || ""}
										onChange={(e) =>
											updateRow(globalIndex, "ref_code", e.target.value)
										}
									/>
								</td>

								{/* <td
									style={{
										position: "relative",
										width: "40px",
									}}
								>
									<img
										src="/Maskgroup.png"
										alt="edit"
										style={{
											position: "absolute",
											top: "50%",
											left: "50%",
											transform: "translate(-50%, -50%)",
											width: "12px",
											height: "12px",
											pointerEvents: "none",
										}}
									/>
								</td> */}
							</tr>
						);
					})}
				</tbody>
			</table>

			<div
				className="d-flex pb-2  justify-content-between align-items-center"
				style={{ marginTop: "12px", marginBottom: "16px" }}
			>
				<div className="d-flex" style={{ gap: "4px" }}>
					{selectedRows.length > 0 && (
						<Button
							onClick={handleDeleteSelectedRows}
							className="customdeletebtn "
							iconName="MdDeleteOutline"
							iconSize={12}
						>
							Delete
						</Button>
					)}
					{selectedRows.length == 0 && (
						<Button
							onClick={handleAddRow}
							className="Addrowdesign"
							iconName="FiPlus"
							iconSize={12}
							iconWrapperStyle={{
								backgroundColor: "#ff8d5c",
								padding: "1px",
								display: "flex",
							}}
						>
							Add Row
						</Button>
					)}
				</div>

				<div
					className={`${
						rows5.length < 11 ? "d-none" : "d-flex"
					} align-items-center centerpagination`}
					style={{ gap: "5px" }}
				>
					<Pagination
						setCurrentPage={setCurrentPage}
						currentPage={currentPage}
						pageSize={rowsPerPage}
						totalrecords={rows5.length}
					/>
				</div>

				<div className={`${rows5.length < 11 ? "d-none" : "d-flex"}`}>
					<span className="px-2" style={{ fontSize: "12px", color: "#270B79" }}>
						Showing {indexOfFirstRow + 1} to{" "}
						{Math.min(indexOfLastRow, rows5.length)} of {rows5.length} entries
					</span>
				</div>
			</div>
		</div>
	);
};

export default Tab4Table1;
